module.exports = __webpack_public_path__ + "static/media/icon4-active.45d16635.svg";